import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore, useUser } from "@/features/auth/store";
import { authCookies } from "@/lib/cookies";
import { AUTH_PATHS } from "@/constants/paths";
import RequiredPasswordChangePage from "@/pages/auth/required-password-change";

/** Authenticated users who must change password before using the app. */
export function RequiredPasswordChangeRoute() {
  const user = useUser();
  const hasAccessToken = Boolean(
    useAuthStore((state) => state.accessToken) ?? authCookies.getAccessToken(),
  );
  const location = useLocation();

  if (!hasAccessToken) {
    return <Navigate to={AUTH_PATHS.LOGIN} state={{ from: location }} replace />;
  }

  const effectiveUser = user ?? authCookies.getUser();
  if (effectiveUser && !effectiveUser.mustChangePassword) {
    return <Navigate to="/" replace />;
  }

  return <RequiredPasswordChangePage />;
}
